module.exports = __webpack_public_path__ + "img/zm.29ac777.svg";